import { Collapse, Divider, List } from '@mui/material'
import React, { useState } from 'react'
import { MobileListItem, MobileListItemProps } from './mobile-list-item'
import {
  MobileSubMenuItem,
  MobileSubMenuItemProps
} from './mobile-sub-menu-item'

const isMenuOpen = (index: number, subMenuOpen: number) => subMenuOpen === index

type MobileSubMenuProps = Omit<
  MobileListItemProps,
  'isCurrentMenuOpen' | 'handleClick'
> &
  Pick<MobileSubMenuItemProps, 'handleMobileMenuClose'>

export const MobileSubMenu = ({
  handleMobileMenuClose,
  index,
  link
}: MobileSubMenuProps) => {
  const [subMenuOpen, setSubMenuOpen] = useState(-1)

  const handleClick = (clickedIndex: number) => {
    if (isMenuOpen(clickedIndex, subMenuOpen)) {
      setSubMenuOpen(-1)
      return
    }
    setSubMenuOpen(clickedIndex)
  }

  const isCurrentMenuOpen = isMenuOpen(index, subMenuOpen)

  const { key, subMenu } = link

  return (
    <span key={key}>
      <MobileListItem
        index={index}
        isCurrentMenuOpen={isCurrentMenuOpen}
        handleClick={handleClick}
        link={link}
      />
      <Collapse in={isCurrentMenuOpen}>
        <List>
          <MobileSubMenuItem
            handleMobileMenuClose={handleMobileMenuClose}
            subMenu={subMenu}
          />
        </List>
      </Collapse>
      <Divider />
    </span>
  )
}
